import { PlatformType } from '../context/socialProvider';
import { API } from './index';
import Cookies from 'js-cookie';

export const fetchUnifiedPosts = async (
  provider: number,
  socialId: string,
  providerId: string
) => {
  try {
    const response = await API.post('/api/v1/posts/unified-fetch-posts', {
      provider,
      socialId,
      providerId,
    });

    return response;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const getUnifiedPosts = async (
  socialId: number,
  options = {
    page: 1,
    pageSize: 25,
    order: 'DESC',
  }
) => {
  try {
    const response = await API.get('/api/v1/unified-posts/list', {
      params: {
        socialId: socialId,
        ...options,
      },
    });

    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

export const getPostById = async (postId: string) => {
  try {
    const response = await API.get(`/api/v1/post/single/${postId}`);

    return response;
  } catch (error: any) {
    throw error.response.data;
  }
};
